import "./App.css";
import Navbar from "./components/NavBar/Navbar";
import CssBaseline from "@mui/material/CssBaseline";
import { Container, ThemeProvider, createTheme } from "@material-ui/core";
import { Fragment } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Compare from "./pages/Compare";
import {
  AuthenticatedTemplate,
  useMsalAuthentication,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import Schedule from "./pages/Schedule";

function App() {
  const darkTheme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#1976d2",
      },
    },
  });

  useMsalAuthentication(InteractionType.Redirect);
  return (
    <Fragment>
      <BrowserRouter>
        <AuthenticatedTemplate>
          <Container maxWidth="xl">
            <ThemeProvider theme={darkTheme}>
              <CssBaseline />

              <Navbar  />
              <Route path="/" component={Dashboard} exact></Route>
              <Route path="/schedule" component={Schedule}></Route>
              <Route path="/compare" component={Compare} ></Route>
            </ThemeProvider>
          </Container>
        </AuthenticatedTemplate>
      </BrowserRouter>
    </Fragment>
  );
}

export default App;
